import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  courseLessonStep,
  showCourseBySlug,
} from "../../../../../redux/actions/courses";
import {
  setFavorite,
  unsetFavorite,
} from "../../../../../redux/actions/favorites";
import { setViewLesson } from "../../../../../redux/actions/lessons";
import { IRootState } from "../../../../../redux/types";
import useGeneralSummaryReport from "../../../../shared/hooks/useGeneralSummaryReport";
import useUserDisplaytime from "../../../../shared/hooks/useUserDisplaytime";
import { MoreInfoDetail } from "../../../library/models/resource";

export const useCourseDetail = (
  brandId: string | undefined,
  slug: string | undefined
) => {
  const { t } = useTranslation(["global"]);
  const dispatch = useDispatch();

  const { course_selected: course, showForm } = useSelector(
    (state: IRootState) => state.course
  );
  const { user: authUser } = useSelector((state: IRootState) => state.auth);
  const { lesson_selected: lesson, showForm: showLessonForm } = useSelector(
    (state: IRootState) => state.lesson
  );
  const [favoriteState, setFavoriteState] = useState<boolean>(false);

  useUserDisplaytime({ foreign: course });
  const { handleViewGeneralSummaryReport } = useGeneralSummaryReport(3);

  useEffect(() => {
    dispatch(showCourseBySlug({ brandId, slug }));
    dispatch(setViewLesson(null));
  }, [brandId, slug, dispatch]);

  useEffect(() => {
    if (course != null && course.slug === slug) {
      if (course.lessons.length === 1 && course.visibility !== 1) {
        dispatch(setViewLesson(course.lessons[0]));
      }
      handleViewGeneralSummaryReport(course.id);

      setFavoriteState(Boolean(course.favoriteId));
    }
  }, [course, slug]);

  const handleChangeLesson = (order: number) => {
    if (!course) return;

    const lessonOrder = course.lessons.find(
      (lesson: any) => lesson.order === order
    );
    if (lessonOrder !== undefined) {
      dispatch(setViewLesson(lessonOrder));
    }

    if (authUser !== null) {
      dispatch(
        courseLessonStep({
          course_id: course.id,
          lesson_order: order,
        })
      );
    }
  };

  const handleFavoriteClick = (course_id: number) => (state: boolean) => {
    if (state) {
      dispatch(
        setFavorite({
          id: course_id,
          type: "course",
        })
      );
    } else {
      dispatch(
        unsetFavorite({
          id: course_id,
          type: "course",
        })
      );
    }
    setFavoriteState(state);
  };

  let infoDetail: MoreInfoDetail = {
    item: course
      ? [
          {
            id: 0,
            type: "tag",
            title: "Tags",
            color: "light",
            info: `${course?.tags
              ?.map((tag: any) => {
                return tag.name.toUpperCase();
              })
              .join(", ")}`,
          },
          {
            id: 1,
            type: "date",
            title: `${t("admin.people.created-date")}`,
            color: "grey6",
            info: `${moment(course?.created_at).format("LL")}`,
          },
        ]
      : [],
  };

  return {
    course,
    lesson,
    authUser,
    showForm,
    showLessonForm,
    favoriteState,
    handleChangeLesson,
    handleFavoriteClick,
    setViewLesson,
    infoDetail,
  };
};
